
const mixin = {
  data() {
    return {};
  },
  mounted() {},
  computed: {},

  methods: {
    mixin_handleModal(from, res) {
      let totalNum = 0,
        successNum = 0,
        errorNum = 0,
        reason = [],
        title = '',
        content = '',
        modalData = {};
      if (from === 'balanceConfirm' || from === 'balanceConfirmSingle') {
        successNum += res.currentConfirm.length;
        errorNum += res.haveConfirmed.length + res.needNotConfirm.length;
        totalNum = successNum + errorNum;
        (title = this.mlang('batchSettlementConfirmationExecutionCompleted')),
          (content = this.mlang('batchSettlementConfirmationInitiatedTotal') + totalNum + this.mlang('bar') + ', ' + this.mlang('success') + successNum + this.mlang('bar') + ', ' + this.mlang('fail') + errorNum + this.mlang('bar')),
          res.haveConfirmed.forEach((item) => {
            reason.push({
              orderNo: item,
              failReason: this.mlang('haveConfirmed'),
            });
          });
        res.needNotConfirm.forEach((item) => {
          reason.push({
            orderNo: item,
            failReason: this.mlang('needNotConfirm'),
          });
        });
        if (from === 'balanceConfirmSingle') {
          title = successNum > 0 ? this.mlang('sSuccessTip') : this.mlang('sFailTip') + reason[0].failReason;
        }
      } else if (from === 'balanceCancelConfirm' || from === 'balanceCancelConfirmSingle') {
        successNum += res.currentDisconfirm.length;
        errorNum += res.currentDisconfirmFailed.length + res.needNotConfirm.length + res.confirmList.length;
        totalNum = successNum + errorNum;
        (title = this.mlang('cancelSettlementConfirmationExecutionCompleted')),
          (content = this.mlang('initiatedCancellationOfSettlementConfirmationTotal') + totalNum + this.mlang('bar') + ', ' + this.mlang('success') + successNum + this.mlang('bar') + ', ' + this.mlang('fail') + errorNum + this.mlang('bar')),
          res.currentDisconfirmFailed.forEach((item) => {
            reason.push({
              orderNo: item,
              failReason: this.mlang('currentDisconfirmFailed'),
            });
          });
        res.needNotConfirm.forEach((item) => {
          reason.push({
            orderNo: item,
            failReason: this.mlang('needNotConfirm'),
          });
        });
        res.confirmList.forEach((item) => {
          reason.push({
            orderNo: item,
            failReason: this.mlang('currentNeedNotConfirmNotCancel'),
          });
        });
        if (from === 'balanceCancelConfirmSingle') {
          title = successNum > 0 ? this.mlang('cancelSettlementConfirmationSuccessful') : this.mlang('cancelSettlementConfirmationFailedReasonForFailure') + reason[0].failReason;
        }
      }
      if (from === 'balanceConfirmSingle' || from === 'balanceCancelConfirmSingle') {
        modalData = {
          successNum,
          title,
        };
      } else {
        modalData = {
          title,
          content,
          successNum,
          errorNum,
          totalNum,
          reason,
        };
      }
      this.$store.commit('SET_INVOICEMODALDATA', modalData);
      this.$store.commit('SET_INVOICEMODALSHOW', true);
    },
  },
};

export default mixin;
